import { jsx as _jsx } from "react/jsx-runtime";
import { Banner, Spinner } from "@neru/ui";
import { useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import { useValidSession } from "../../hooks";
var REDIRECT_KEY = "vch.signed_in";
var REDIRECT_DELAY_MS = 5000;
export var SecureRouteWithCookie = function() {
    var hasSession = useValidSession();
    var timeoutRef = useRef();
    var signInAttempted = sessionStorage.getItem(REDIRECT_KEY);
    var clearSessionCheck = function() {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = undefined;
        }
        sessionStorage.removeItem(REDIRECT_KEY);
    };
    // Trigger user authorization on secure routes (launch workspace from Customer Dashboard)
    useEffect(function() {
        if (hasSession) {
            clearSessionCheck();
            return;
        }
        if (!signInAttempted) {
            timeoutRef.current = setTimeout(function() {
                if (!hasSession) {
                    sessionStorage.setItem(REDIRECT_KEY, "true");
                    var path = encodeURIComponent("".concat(window.location.pathname).concat(window.location.search));
                    window.location.href = "/sign-in?redirect=".concat(path);
                }
            }, REDIRECT_DELAY_MS);
        }
        return function() {
            clearSessionCheck();
        };
    }, [
        hasSession,
        signInAttempted
    ]);
    if (hasSession) {
        return /*#__PURE__*/ _jsx(Outlet, {});
    }
    if (signInAttempted) {
        return /*#__PURE__*/ _jsx(Banner, {
            connotation: "info",
            message: "Please sign in to access this page.",
            open: true
        });
    }
    return /*#__PURE__*/ _jsx(Spinner, {
        "data-testid": "pending-cookie-auth"
    });
};

//# sourceMappingURL=SecureRouteWithCookie.js.map